/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Item_Not_VotableInputs */

const en_us2_community_item_not_votable = /** @type {(inputs: Community_Item_Not_VotableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This item no longer takes votes.`)
};

const pt_br2_community_item_not_votable = /** @type {(inputs: Community_Item_Not_VotableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse item não está mais aberto a votos.`)
};

const es_419_community_item_not_votable = /** @type {(inputs: Community_Item_Not_VotableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este elemento ya no está abierto a votos.`)
};

const pt_pt2_community_item_not_votable = /** @type {(inputs: Community_Item_Not_VotableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este item já não está aberto a votos.`)
};

const fr_fr2_community_item_not_votable = /** @type {(inputs: Community_Item_Not_VotableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet élément n'est plus ouvert aux votes.`)
};

const de_de2_community_item_not_votable = /** @type {(inputs: Community_Item_Not_VotableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für diesen Eintrag kann nicht mehr abgestimmt werden.`)
};

const it_it2_community_item_not_votable = /** @type {(inputs: Community_Item_Not_VotableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo elemento non accetta più voti.`)
};

/**
* | output |
* | --- |
* | "This item no longer takes votes." |
*
* @param {Community_Item_Not_VotableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_item_not_votable = /** @type {((inputs?: Community_Item_Not_VotableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Item_Not_VotableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_item_not_votable(inputs)
	if (locale === "es-419") return es_419_community_item_not_votable(inputs)
	if (locale === "pt-PT") return pt_pt2_community_item_not_votable(inputs)
	if (locale === "fr-FR") return fr_fr2_community_item_not_votable(inputs)
	if (locale === "de-DE") return de_de2_community_item_not_votable(inputs)
	if (locale === "it-IT") return it_it2_community_item_not_votable(inputs)
	return en_us2_community_item_not_votable(inputs)
});
export { community_item_not_votable as "community.item_not_votable" }